<template>
  <div :style="$vuetify.breakpoint.mdAndUp ? 'height:100%;' : ''">
    <v-row class="hidden-md-and-up mobile-header no-gutters">
      <v-col cols="6" class="mobile-header-item" :class="[this.selectedTab == 'REBATE' ? 'selected' : '']" @click="onChangeTab('REBATE')">
        <div style="text-decoration: unset !important">
          <span>{{ $t(`button.rebate`) }}</span>
        </div>
      </v-col>
      <v-col cols="6" class="mobile-header-item" :class="[this.selectedTab == 'REBATE_HISTORY' ? 'selected' : '']" @click="onChangeTab('REBATE_HISTORY')">
        <div style="text-decoration: unset !important">
          <span>{{ $t(`label.rebateHistory`) }}</span>
        </div>
      </v-col>
    </v-row>
    <v-card class="desktop_card" elevation="0">
      <v-card-title class="justify-space-between" v-if="$vuetify.breakpoint.mdAndUp">
        <label class="--v-primary-base text-left">{{ $t(`label.instantRebate`) }}</label>
      </v-card-title>
      <v-row v-if="$vuetify.breakpoint.lgAndUp" no-gutters justify="end" class="px-10">
        <v-col class="text-right" cols="12">
          <v-btn class="history-tab" :class="selectedTab == 'REBATE' ? 'history-tab-active': ''" depressed @click="onChangeTab('REBATE')">
            {{ $t(`button.rebate`) }}
          </v-btn>
          <v-btn class="history-tab" :class="selectedTab == 'REBATE_HISTORY' ? 'history-tab-active': ''" depressed @click="onChangeTab('REBATE_HISTORY')">
            {{ $t(`label.rebateHistory`) }}
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="$vuetify.breakpoint.lgAndUp" class="rebate-divider"></div>
      <v-card class="bank-detail-card" elevation="0">
        <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp">
          <v-col cols="12" v-if="selectedTab == 'REBATE'" class="fullHeight">
            <v-row no-gutters class="rebate-container">
              <div class="left-rebate-container">
                <span class="text-pending">{{ $t(`label.totalPendingClaim`) }}</span>
                <span class="text-unclaimed">{{ (totalRebate.unclaimed ? totalRebate.unclaimed : 0) | currency(currentCurrency) }}</span>
              </div>
              <div class="right-rebate-container">
                <v-btn
                    height="40"
                    @click="claimRebate()"
                    depressed
                    class="btn-claim"
                >
                  {{ $t(`label.claimAll`) }}
                </v-btn>
                <div>
                  <span class="text-date">{{ `${$t(`label.lastUpdated`)} ` }}</span>
                  <span class="text-date" v-if="lastUpdated.last_updated">{{ lastUpdated.last_updated | longDate }}</span>
                  <span class="text-date" v-else>: -</span>
                </div>
              </div>
            </v-row>
            <div class="rebate-divider"></div>
            <div v-for="(rebates, gameType) in rebateProviderList" :key="gameType" >
              <h2 style="margin-top: 12px; margin-bottom: 6px;">{{ $t(`label.${gameType.toLowerCase()}`) }}</h2>
              <v-data-table light :headers="rebateProviderHeaders" :items="rebates" class="elevation-0 fullHeight" :hide-default-footer="true" hide-default-header :items-per-page="-1">
                <template v-slot:header="{ props }">
                  <tr style="background-color: #F3F5F6;">
                    <th class="referral-table-header text-start" style="padding: 10px 16px" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                    </span>
                    </th>
                  </tr>
                </template>

                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ $t(`label.${item.vip_level_name.toLowerCase()}`) }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ item.provider_code }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ `${item.vip_percentage}%` }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ item.valid_bet_amount | currency(currentCurrency) }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ item.rebate_amount | currency(currentCurrency)}}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-col>
          <v-col cols="12" v-if="selectedTab == 'REBATE_HISTORY'" class="fullHeight">
            <v-row no-gutters class="pa-3" align="center" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
              <v-col cols="8"></v-col>
              <v-col cols="4">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="dateRangeText"
                        clearable
                        @click:clear="clearFilter()"
                        outlined
                        class="date-search ml-3 elevation-0"
                        hide-details="true"
                        v-on="on"
                        append-icon="search"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" @input="selectedDate()" range></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-data-table light :headers="rebateHeaders" :items="transactionList" class="elevation-0 fullHeight" :hide-default-footer="true" hide-default-header :items-per-page="-1">
              <template v-slot:header="{ props }">
                <tr>
                  <th class="referral-table-header text-start" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                      <span v-if="head.sortable">
                        <v-icon v-if="head.sortBy == 'asc'" @click="sortTableList(head)">arrow_drop_down</v-icon>
                        <v-icon v-if="head.sortBy == 'desc'" @click="sortTableList(head)">arrow_drop_up</v-icon>
                      </span>
                    </span>
                  </th>
                </tr>
              </template>

              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-start" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                    {{ item.bet_time_end | longDate }}
                  </td>
                  <td class="text-start" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                    {{ item.valid_bet_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                    {{ item.vip_percentage }}
                  </td>
                  <td class="text-start" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                    {{ item.rebate_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                    {{ item.provider_code }}
                  </td>
                  <td class="text-start" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                    {{ item.game_type }}
                  </td>
                  <td class="text-start text-capitalize" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                    {{ item.fk_rebate_status_id == 1 ? $t(`label.unclaimed`) : $t(`label.claimed`) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row no-gutters v-else>
          <v-col cols="12" v-if="selectedTab == 'REBATE'" class="fullHeight">
            <v-row no-gutters class="rebate-container">
              <div class="left-rebate-container">
                <span class="text-pending">{{ $t(`label.totalPendingClaim`) }}</span>
                <span class="text-unclaimed">{{ (totalRebate.unclaimed ? totalRebate.unclaimed : 0) | currency(currentCurrency) }}</span>
              </div>
              <div class="right-rebate-container">
                <v-btn
                    height="40"
                    @click="claimRebate()"
                    depressed
                    class="btn-claim"
                >
                  {{ $t(`label.claimAll`) }}
                </v-btn>
                <div>
                  <span class="text-date">{{ `${$t(`label.lastUpdated`)} ` }}</span>
                  <span class="text-date" v-if="lastUpdated.last_updated">{{ lastUpdated.last_updated | longDate }}</span>
                  <span class="text-date" v-else>: -</span>
                </div>
              </div>
            </v-row>

            <div v-for="(rebates, gameType) in rebateProviderList" :key="gameType" class="mobile-rebate-table">
              <h2 style="margin-top: 12px; margin-bottom: 6px;">{{ $t(`label.${gameType.toLowerCase()}`) }}</h2>
              <v-data-table light :headers="rebateProviderHeaders" :items="rebates" class="elevation-0 fullHeight" :hide-default-footer="true" hide-default-header :items-per-page="-1">
                <template v-slot:header="{ props }">
                  <tr style="background-color: #F3F5F6;">
                    <th class="referral-table-header text-start" style="padding: 10px 16px" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                    </span>
                    </th>
                  </tr>
                </template>

                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ $t(`label.${item.vip_level_name.toLowerCase()}`) }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ item.provider_code }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ `${item.vip_percentage}%` }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ item.valid_bet_amount | currency(currentCurrency) }}
                    </td>
                    <td class="text-start" style="padding: 10px 16px">
                      {{ item.rebate_amount | currency(currentCurrency)}}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-col>
          <v-col cols="12" class="pt-4 pb-2 px-4" v-if="this.selectedTab == 'REBATE_HISTORY'">
            <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateRangeText"
                  clearable
                  @click:clear="clearFilter()"
                  color="buttonPrimary"
                  outlined
                  class="date-search-mobile mb-3 elevation-0"
                  hide-details="true"
                  v-on="on"
                  append-icon="search"
                ></v-text-field>
              </template>
              <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" @input="selectedDate()" range></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" v-if="this.selectedTab == 'REBATE_HISTORY'">
            <v-row v-for="(item, index) in transactionList" :key="index" class="mobile-history-table">
              <v-col cols="6" class="mr-0">
                <v-row no-gutters class="referral-table-header pl-6">
                  <v-col cols="12" v-for="h in rebateHeaders" :key="h.text">
                    {{ $t(`label.${h.text}`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    {{ item.bet_time_end | longDate }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.valid_bet_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.vip_percentage }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.rebate_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.provider_code }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.game_type }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.fk_rebate_status_id == 1 ? $t(`label.claimed`) : $t(`label.unclaimed`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="transactionList.length == 0 && this.selectedTab == 'REBATE_HISTORY'" class="text-center pt-0 pb-8">
            <label class="referral-table-header subtitle-2">{{ $t(`message.noDataAvaliable`) }}</label>
          </v-col>
        </v-row>
      </v-card>
<!--      <v-row no-gutters class="mt-4" v-if="pagination.last_page > 1">-->
<!--        <v-col cols="12" class="text-center">-->
<!--          <v-pagination-->
<!--            class="trxn_history_pagination"-->
<!--            v-model="pagination.current_page"-->
<!--            :length="pagination.last_page"-->
<!--            @input="changePage"-->
<!--            :next-icon="'arrow_forward_ios'"-->
<!--            :prev-icon="'arrow_back_ios'"-->
<!--            :total-visible="10"-->
<!--          ></v-pagination>-->
<!--        </v-col>-->
<!--      </v-row>-->
    </v-card>
    <v-snackbar v-model="showAlert" :timeout="notiMsgTimeout" top centered light class="pa-0" width="fit-content">
      <v-alert
        class="mb-0 pa-1"
        dense
        v-model="showAlert"
        dismissible
        light
        close-icon="close"
        :icon="alertSuccess ? 'check_circle' : 'cancel'"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
  </div>
</template>

<script>
import rebateHistory from '@/assets/svg/rebate-history.svg'
import { uiHelper, locale, errorCodeHelper, formValidator } from '@/util'
import { SHARED } from '@/constants/constants'
import _ from 'lodash'
import { REBATE_HISTORY, CLAIM_REBATE, REBATE_PROVIDER } from '@/store/bonus.module'
import { CHECK_STATUS, PAYMENT_HISTORY, RESET_CHECK_STATUS_RESPONSE } from '@/store/payment.module'

export default {
  name: 'instantRebate',
  components: {
    rebateHistory
  },
  data: () => ({
    copiedIndex: null,
    showCopySuccess: false,
    dateMenu: false,
    showAlert: false,
    alertMessage: '',
    alertSuccess: true,
    notiMsgTimeout: 4000,
    dates: ['', ''],
    language: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: 'REBATE',
    msgDialog: {
      show: false
    },
    inboxList: [],
    announcementList: [],
    selectedList: [],
    pagination: {
      currentPage: 1,
      totalPage: 1,
      paginationPageLimit: 10
    },
    searchCriteria: {
      pageNumber: 1,
      pageSize: 20,
      mobilePageSize: 10
    },
    rebateHeaders: [
      {
        text: 'date',
        align: 'start',
        sortable: true,
        value: 'bet_time_end',
        sortBy: 'desc'
      },
      {
        text: 'valid',
        value: 'valid_bet_amount',
        sortable: false
      },
      {
        text: 'rebate',
        value: 'vip_percentage',
        sortable: false
      },
      {
        text: 'rebateAmount',
        value: 'rebate_amount',
        sortable: false
      },
      {
        text: 'provider',
        value: 'activity',
        sortable: false
      },
      {
        text: 'category',
        value: 'provider_code',
        sortable: false
      },
      {
        text: 'status',
        value: 'status',
        sortable: false
      }
    ],
    transactionList: [],
    rebateProviderList: [],
    rebateProviderHeaders: [
      {
        text: 'memberLevel',
        value: 'vip_level_name'
      },
      {
        text: 'provider',
        value: 'provider_code'
      },
      {
        text: 'rebate',
        value: 'vip_percentage'
      },
      {
        text: 'validBet',
        value: 'valid_bet_amount'
      },
      {
        text: 'rebateEarned',
        value: 'rebate_amount'
      }
    ],
    selectedPage: 1
  }),
  created() {
    this.metaTag()
    this.getRebateHistory()
    this.getRebateProvider()
  },
  computed: {
    dateRangeText: {
      get() {
        let startDate = this.dates[0] ? this.dates[0] : ''
        let endDate = this.dates[1] ? this.dates[1] : ''
        return startDate + ' - ' + endDate
      },
      set(dateRange) {
        this.dates = []
      }
    },
    rebateHistory() {
      return this.$store.state.bonus.rebateHistory.data
    },
    rebateProvider() {
      console.log('rebateProvider', this.$store.state.bonus.rebateProvider)
      return this.$store.state.bonus.rebateProvider
    },
    rebateHistoryPagination() {
      return this.$store.state.bonus.rebateHistory.pagination
    },
    totalRebateAmt() {
      if (this.selectedTab == 'REBATE_HISTORY') {
        let amt = 0
        this.$store.state.bonus.rebateHistory.data.forEach(b => {
          amt += b.rebate_amount
        })
        return amt
      }
      return 0
    },
    totalRebatePercentage() {
      if (this.selectedTab == 'REBATE_HISTORY') {
        let amt = 0
        this.$store.state.bonus.rebateHistory.data.forEach(b => {
          amt += b.vip_percentage
        })
        return amt
      }
      return 0
    },
    totalRebate() {
      return this.$store.state.bonus.rebateHistory.totalRebate
    },
    lastUpdated() {
      return this.$store.state.bonus.rebateHistory.claimed
    },
    claimRebateResult() {
      return this.$store.state.bonus.claimRebateResult.complete
    },
    checkStatusResponse() {
      return this.$store.state.payment.checkStatusResponse.complete
    },
    paymentHistory() {
      return this.$store.state.payment.paymentHistory.data
    },
    paymentHistoryPagination() {
      return this.$store.state.payment.paymentHistory.pagination
    },
  },
  watch: {
    rebateHistory() {
      this.getTransactionList()
    },
    claimRebateResult() {
      if (this.$store.state.bonus.claimRebateResult.complete) {
        this.claimRebateResponse(this.$store.state.bonus.claimRebateResult)
      }
    },
    checkStatusResponse() {
      let response = this.$store.state.payment.checkStatusResponse
      if (response.code === 1) {
        this.alertSuccess = response.success
        this.alertMessage = response.message
        this.showAlert = true
      } else {
        this.alertSuccess = false
        this.alertMessage = response.message
        this.showAlert = true
      }
    },
    rebateProvider() {
      this.rebateProviderList = this.$store.state.bonus.rebateProvider;
    }
  },
  methods: {
    copyTransID(transID, index) {
      navigator.clipboard
        .writeText(transID)
        .then(() => {
          this.copiedIndex = index // Set the copied index
          this.showCopySuccess = true // Show success message for the copied item
          console.log('Successfully copied trans id :' + transID)
          setTimeout(() => {
            this.showCopySuccess = false // Hide message after 2 seconds
          }, 2000)
        })
        .catch(err => {
          console.error('Error copying trans ID to clipboard: ', err)
        })
    },
    isExpired(timestamp) {
      const threeDaysAgo = new Date()
      threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
      const itemDate = new Date(timestamp)

      return itemDate < threeDaysAgo
    },
    metaTag() {
      const currentUrl = window.location.href
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`

      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    selectedDate() {
      if (this.dates[0] && this.dates[1]) {
        let self = this
        setTimeout(function() {
          self.dateMenu = false
        }, 500)
      }
    },
    changePage(targetPage) {
      this.selectedPage = targetPage
      this.getRebateHistory()
      if (this.selectedTab == 'REBATE') {
        this.getRebateProvider()
      }
    },
    checkStatus(transactionId) {
      let obj = {
        transactionId: transactionId
      }
      this.showAlert = false
      this.$store.dispatch(`${CHECK_STATUS}`, { obj })
      this.$store.dispatch(`${RESET_CHECK_STATUS_RESPONSE}`)
      this.getPaymentHistory(this.selectedTab)
    },
    closeAlertDialog() {
      this.showAlert = false
    },
    onChangeTab(type, filterDate) {
      this.selectedTab = type
      if (!filterDate) {
        this.dates = ['', '']
      }

      this.selectedPage = 1
      if (this.selectedTab == 'REBATE') {
        this.getRebateProvider()
      }
      // } else if (this.selectedTab == 'REBATE_HISTORY') {
        this.getRebateHistory()
      // }
    },
    getPaymentHistory(type) {
      let obj = {
        type: type,
        startTime: this.dates[0],
        endTime: this.dates[1],
        size: 10,
        page: this.selectedPage
      }
      this.$store.dispatch(`${PAYMENT_HISTORY}`, {
        obj
      })
    },
    getRebateHistory(type) {
      let obj = {
        type: type,
        startTime: this.dates[0],
        endTime: this.dates[1],
        size: 10,
        page: this.selectedPage
      }
      this.$store.dispatch(`${REBATE_HISTORY}`, {
        obj
      })
    },
    getRebateProvider() {
      let obj = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${REBATE_PROVIDER}`, {
        obj
      })
    },
    getTransactionList() {
      if (this.selectedTab == 'REBATE') {
        this.transactionList = []
        this.pagination = this.paymentHistoryPagination
      } else {
        this.transactionList = _.cloneDeep(this.rebateHistory)
        this.pagination = this.rebateHistoryPagination
      }
    },
    clearFilter() {
      this.dates = []
      this.onChangeTab(this.selectedTab)
    },
    filterListByDate() {
      this.onChangeTab(this.selectedTab, true)
    },
    claimRebate() {
      this.$store.dispatch(`${CLAIM_REBATE}`)
    },
    claimRebateResponse(result) {
      if (result.success && result.code == 0) {
        this.$parent.openAlert(true, locale.getMessage(`message.rebateSubmitSuccess`))
      } else {
        this.$parent.openAlert(false, locale.getMessage(`message.vipBonusFailed`))
      }
    },
    sortTableList(obj) {
      let headers = this.rebateHeaders

      let sortBy = _.filter(headers, function(d) {
        return d.sortable
      })
      if (obj) {
        let selected = _.find(sortBy, function(d) {
          if (d.value == obj.value) {
            d.sortBy = d.sortBy == 'asc' ? 'desc' : 'asc'
            return true
          }
        })
      }
      this.transactionList = _.orderBy(this.transactionList, _.map(sortBy, 'value'), _.map(sortBy, 'sortBy'))
    }
  }
}
</script>

<style lang="scss">
.fullHeight {
  height: 100%;
  .v-data-table__wrapper {
    height: 100%;
  }
}
.desktop_card {
  margin-left: 12px;
  @media (max-width: 959px) {
    margin-left: 0px;
  }
}

.copyButton {
  height: 25px !important;
  width: 45px !important;
  min-width: 30px !important;
}
.checkButton {
  height: 25px !important;
  //width: 45px !important;
  min-width: 30px !important;
}
.copy-success-message {
  color: #4caf50;
  font-size: 12px;
}
.filter-card-wrapper {
  max-width: 959px;
  white-space: nowrap;
  overflow: auto;
  display: flex;
  align-items: center;
  background-color: var(--v-text-base);
  border-bottom: 1px solid #dadada;
  background-color: #fff;
  flex-wrap: nowrap;
  overflow-x: auto;
  justify-content: flex-start;
  padding: 12px 12px 12px 12px;

  .wrapper-col {
    gap: 0.5rem;
  }

  .game-menu-content.v-card {
    //display:flex;
    min-width: 50px;
    width: 65px;
    height: 65px;
    text-transform: capitalize;
    padding: 12px 0px 10px !important;
    background-color: #333333;
    color: #ffffff;
    border-radius: 10px !important;
  }

  .toStatus-card-image {
    background-color: #ffffff;
    -webkit-mask-image: var(--src);
    mask-image: var(--src);
    -webkit-mask-size: 100%;
    mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    width: 30px;
    height: 35px;
    margin-left: 8px;

    &.selected {
      background-color: #ffffff;
    }
  }

  .game-menu-title {
    text-align: center;
    font-size: 12px;
  }

  .game-menu-content {
    &.selected {
      color: #ffffff;
      opacity: 1;
      background: var(--v-newMobilePrimary-base);

      .game-menu-image {
        background-color: #000000;
      }
    }
  }
}

.trxn_history_pagination .v-pagination {
  li {
    border: none !important;

    button {
      border: none !important;
      font-size: 14px;
    }
  }
}

.mobile-history-table {
  .col-12 {
    min-height: 20px;
  }
}

.history-card {
  height: 75%;
  overflow-x: hidden;
  overflow-y: scroll;

  .date-search {
    width: fit-content;
    margin-right: 0px;
    float: right !important;

    .v-input__slot {
      min-height: 40px !important;
      max-width: 250px;
    }

    .v-input__append-inner {
      margin-top: 8px;
    }
  }

  .referral-table-header {
    color: #acacac;
  }
}


.rebate-divider {
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background-color: #D3D3D3;
}

.rebate-container {
  width: 100%;
  height: 100px;
  padding: 20px 16px;
  border-radius: 8px;
  background-color: #F3F5F6;

  @media (max-width: 599px) {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .left-rebate-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 220px);

    @media (max-width: 599px) {
      width: 100%;
    }
  }

  .right-rebate-container {
    display: flex;
    flex-direction: column;
    width: 220px;
    align-items: flex-end;

    @media (max-width: 599px) {
      width: 100%;
      margin-top: 12px;
      align-items: center;
    }
  }

  .text-pending, .text-date {
    font-size: 14px;
    color: #6c6c6c;
  }

  .text-unclaimed {
    margin-top: 6px;
    font-size: 22px;
    font-weight: bold;
    color: #47206F;
  }

  .btn-claim {
    width: 180px;
    height: 40px;
    margin-bottom: 6px;
    border-radius: 12px;
    color: white !important;
    background-color: #FF9E2D !important;
  }
}

.history-tab {
  width: 150px;
  margin-right: 16px;
  padding: 10px;
  background-color: #fff;
  text-transform: capitalize;

  .mobile-icon {
    margin-right: 5px;
    width: 15px;
    height: 19px;
  }

  .mobile-icon-active {
    fill: #3a3a3a !important;

    path {
      fill: #fff !important;
    }
  }
}

.history-tab-active {
  color: white !important;
  background-color: #47206F !important;
}

.history-tab-mobile {
  width: fit-content !important;
  margin-right: 5px;
  min-width: fit-content !important;
  padding: 2px;
  background-color: #fff;
  text-transform: capitalize;
  font-size: 12px !important;

  .mobile-icon {
    margin-right: 3px;
    width: 15px;
    height: 19px;
  }

  .mobile-icon-active {
    fill: #3a3a3a !important;

    path {
      fill: #fff !important;
    }
  }
}

.date-search-mobile {
  .v-input__slot {
    min-height: 40px !important;
  }

  .v-input__append-inner {
    margin-top: 8px;
  }
}

@media (max-width: 599px) {
  .filter-card-wrapper {
    .game-menu-content.v-card {
      height: 60px !important;
    }

    .toStatus-card-image {
      width: 25px !important;
      height: 30px !important;
    }

    .game-menu-title {
      font-size: 0.7rem;
    }
  }
}

@media (max-width: 959px) {
  .history-card {
    font-size: 12px;
    height: 80%;
    overflow-x: hidden;
    overflow-y: hidden;

    .date-search {
      width: fit-content;
      margin-right: 0px;
      float: right !important;

      .v-input__slot {
        min-height: 40px !important;
        max-width: 250px;
      }

      .v-input__append-inner {
        margin-top: 8px;
      }
    }

    .referral-table-header {
      color: #acacac;
    }
  }
}

.mobile-header {
  background-color: var(--v-newMobilePrimary-base);
  color: white;
  height: 50px;

  .mobile-header-item {
    display: flex;
    justify-content: center;
    align-items: center;

    &.selected {
      border-bottom: 5px solid var(--v-newMobileSecondary-base);
    }
  }
}

.mobile-rebate-table {
  .v-data-table--mobile>.v-data-table__wrapper tbody {
    display: contents;
  }
}
</style>
